const defaultBookmark = {
    type: "", // functional type: section, timestamp
    time: 0,
    tags: [],
    text: "",
    color: "",
    notes: "",
    duration: 0,
}

function insertBookmark (
    bookmarks, setBookmarks,
    newBookmark
) {
    const sortedBookmarks = [...bookmarks, newBookmark ];
    sortBookmarks(sortedBookmarks)
    setBookmarks(sortedBookmarks);
    const index = sortedBookmarks.findIndex(b => b.time === newBookmark.time)
    return index
}

function sortBookmarks(bookmarks) {
    const typePriority = {
        'section': 1,
        'timestamp': 2
    };
    bookmarks.sort((a, b) => {
        if (a.time !== b.time) {
            return a.time - b.time;
        }
        return typePriority[a.type] - typePriority[b.type];
    });
}

function updateBookmarks (bookmarks, setBookmarks, index, updateDict){
    if (index >= 0 && index < bookmarks.length) {
        // Create a new array with updated item
        const newItems = bookmarks.map((bm, idx) => {
            if (idx === index) {
                return { ...bm, ...updateDict }; // Merge existing item with updates
            }
            return bm;
        });
        setBookmarks(newItems); // Set the new state
    } else {
        alert("invalid index provided");
    }
}

function deleteBookmark(bookmarks, setBookmarks, index) {
    if (bookmarks.length > (1 + 1)) {
        if (index === 0) {
          const second_bookmark = bookmarks[1];
          second_bookmark.time = bookmarks[0].time;
          const update = [
            second_bookmark,
            ...bookmarks.slice(2)
          ];
          setBookmarks(update)
        } else {
          const update = [
            ...bookmarks.slice(0, index),
            ...bookmarks.slice(index+1)
          ];
          setBookmarks(update)
        }
      }
}

function typeIndexToBookmarkIndex(type, bookmarks, typeIndex) {
    const typeIndices = bookmarks.reduce((acc, bm, index) => {
        if (bm.type === type) {
            acc.push(index);
        }
        return acc;
    }, []);
    return typeIndices[typeIndex]
}

function indexForNextOfType(type, bookmarks, bookmarkIndex, n=1) {
    //TODO this needs to be done better. it slows things down
    const typeIndices = bookmarks.reduce((acc, bm, index) => {
        if (index >= bookmarkIndex ) {
            if (bm.type === type) {
                acc.push(index);
            }
        }
        return acc;
    }, []);
    return typeIndices[n]
}


// SECTION
//---------
function getSections(bookmarks) {
    return bookmarks.filter(bm => bm.type === 'section');
}

function getSectionForIndex(bookmarks, sectionIndex) {
    if (sectionIndex < 0 || sectionIndex > bookmarks.length - 1) {
        return null;
    }
    return getSections(bookmarks)[sectionIndex];
}

function isSectionTime(bookmark, time) {
    const sections = getSections(bookmark)
    const section_times = sections ? sections.map((value) => value.time) : [];
    return section_times.includes(time)
}

function insertSection (
    bookmarks, setBookmarks,
    time,
    tags = defaultBookmark.tags,
    text = defaultBookmark.text,
    color = defaultBookmark.color,
    notes = defaultBookmark.notes,
    duration = defaultBookmark.duration
) {
    // returns the section index
    if (isSectionTime(bookmarks, time)) {
        const sections = getSections(bookmarks)
        return sections.findIndex(b => b.time === time)
    }
    const index = insertBookmark(bookmarks, setBookmarks, {
        'type': 'section',
        'time': time,
        'tags': tags,
        'text': text,
        'color': color,
        'notes': notes,
        'duration': duration
    });
    return typeIndexToBookmarkIndex('section', bookmarks, index)
}

function updateSection (
    bookmarks, setBookmarks,
    index,
    updateDict
) {
    if (bookmarks[index].type === 'section'){
        updateBookmarks(bookmarks, setBookmarks, index, updateDict)
    } else {
        alert("section update on non-section item")
    }
}

function deleteSection (bookmarks, setBookmarks, sectionIndex) {
    const index = typeIndexToBookmarkIndex('section', bookmarks, sectionIndex);
    defaultBookmark(bookmarks, setBookmarks, index);
}


// Timestamp
//-----------
function getTimestamps(bookmarks, type) {
    return bookmarks.filter(bm => bm.type === 'timestamp');
}

function isTimestampTime(bookmark, time) {
    const timestamps = getTimestamps(bookmark)
    const timestamps_times = timestamps ? timestamps.map((value) => value.time) : [];
    return timestamps_times.includes(time)
}

function insertTimestamp (
    bookmarks, setBookmarks,
    time,
    text = defaultBookmark.text,
    notes = defaultBookmark.notes,
    tags = defaultBookmark.tags,
    color = defaultBookmark.color,
    duration = defaultBookmark.duration
) {
    // returns the section index
    if (isTimestampTime(bookmarks, time)) {
        const timestamps = getTimestamps(bookmarks)
        return timestamps.findIndex(b => b.time === time)
    }
    const index = insertBookmark(bookmarks, setBookmarks, {
        'type': 'timestamp',
        'time': time,
        'tags': tags,
        'text': text,
        'color': color,
        'notes': notes,
        'duration': duration
    });
    return typeIndexToBookmarkIndex('timestamp', bookmarks, index)
}

function updateTimestamp (
    bookmarks, setBookmarks,
    index,
    updateDict
) {
    if (bookmarks[index].type === 'timestamp'){
        updateBookmarks(bookmarks, setBookmarks, index, updateDict)
    } else {
        alert("timestamp update on non-timestamp item")
    }
}

// Utilities
//-----------

function parseTimeString(input) {
    // Define a regular expression to match the time at the beginning of the string
    const timeRegex_min = /^[\[\(]?(\d{1,2}):(\d{1,2})[\]\)]?\s+(.*)$/;
    const timeRegex_hours = /^[\[\(]?(\d{1,2}):(\d{1,2}):(\d{1,2})[\]\)]?\s+(.*)$/;
    
    // Use the regular expression to extract the time and the rest of the string
    if (input.match(timeRegex_min)){
        const match = input.match(timeRegex_min);
        var hours = 0;
        var minutes = parseInt(match[1], 10);
        var seconds = parseInt(match[2], 10);
        var text = match[3];
    } else if (input.match(timeRegex_hours)){
        const match = input.match(timeRegex_hours);
        var hours = parseInt(match[1], 10);
        var minutes = parseInt(match[2], 10);
        var seconds = parseInt(match[3], 10);
        var text = match[4];
    } else {
        return {
            timeInSeconds: -1,
            text: input
        };
    }
  
    // Convert the time to total seconds
    const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
  
    // Return the total seconds and the remaining text
    return {
      timeInSeconds: totalSeconds,
      text: text
    };
}

async function StringToBookmarks(timeStampString, bookmarks, setBookmarks) {
    const lines = timeStampString.split('\n');
    var parse_results;
    var updatedBookmarks = Array.isArray(bookmarks) ? [...bookmarks] : []; // Work with a copy of the current bookmarks
 
    const setUpdatedBookmarks = (newBookmarks) => {
        updatedBookmarks = newBookmarks;
    };

    for (let line of lines) {
      parse_results = parseTimeString(line);
      if (parse_results.timeInSeconds == 0) {
        await updateBookmarks(
            updatedBookmarks, 
            setUpdatedBookmarks, 
            0, 
            {text: parse_results.text}
        )
      } else if ((parse_results.timeInSeconds > 0) 
        && (parse_results.timeInSeconds < updatedBookmarks[updatedBookmarks.length -1].time)
        ){
        await insertSection(
          updatedBookmarks,
          setUpdatedBookmarks,
          parse_results.timeInSeconds,
          defaultBookmark.tags,
          parse_results.text
        );
      }
    }
  
    setBookmarks(updatedBookmarks); // Finally set the updated bookmarks
  }
 
  

export {insertBookmark, sortBookmarks, updateBookmarks, deleteBookmark, typeIndexToBookmarkIndex, indexForNextOfType,
    getSections, isSectionTime, insertSection, updateSection, deleteSection, getTimestamps, isTimestampTime, 
    insertTimestamp, updateTimestamp, StringToBookmarks, getSectionForIndex}
